import { COMPANY_NAMES, randomId } from "../shared";

interface ChargeDetailRecord {
  amountInCents?: number;
  centsPerWh?: number;
  consumedInWattHours?: number;
  chargingTime?: {
    days?: number;
    hours?: number;
    minutes?: number;
    seconds?: number;
  };
  customerName?: string;
  endedAt?: string;
  locationName?: string;
  startedAt?: string;
  tagIdLabel?: string;
  transactionId: number;
}

function generateMockChargeDetailRecord({
  transactionId = randomId(),
  ...overrides
}: Partial<ChargeDetailRecord> = {}): ChargeDetailRecord {
  return {
    transactionId,
    startedAt: "2026-06-03T06:10:00.000Z",
    endedAt: "2026-06-03T09:55:00.000Z",
    locationName: "Aarhus Nord",
    customerName: COMPANY_NAMES.pendingClean,
    tagIdLabel: `TAG-${String(transactionId)}`,
    consumedInWattHours: 18_400,
    centsPerWh: 0.21,
    amountInCents: 38_64,
    chargingTime: { hours: 1, minutes: 24, seconds: 0 },
    ...overrides,
  };
}

export { generateMockChargeDetailRecord };
export type { ChargeDetailRecord };
